module.exports = __webpack_public_path__ + "static/media/kr.e7ceeb08.svg";